angular.module('services.error.ErrorService', [
  'global'
])

/**
 * The ErrorService handles http error conditions
 *
 * @class ErrorService
 * @constructor
 * @module services.error.ErrorService
 */
.factory('ErrorService', [
  '$location',
  '$rootScope',
  '$state',
  '$window',
  function ($location, $rootScope, $state, $window) {
    'use strict';

    var service = {

      count: 0,

      requestError: function (response) {
        var metadata = {
          error: response,
          state: $state.current
        };
        console.log('API Error', metadata);
        service.count += 1;

        if (service.count < 25) {
          if (_.includes(JSON.stringify(response), 'token')) {
            console.log('token error');
            $window.localStorage.removeItem('newman');
            $state.go('routes.login', null, { reload: true });
          }

          if (response.status === 400 || response.status === 403) {
            $state.go('routes.badRequest', metadata);
          } else if (response.status === 401) {
            $window.localStorage.removeItem('newman');
            $state.go('routes.login', metadata);
          } else if (response.status === 404) {
            $state.go('routes.notFound', metadata);
          } else if (response.status === 429) {
            $state.go('routes.tooManyRequests', metadata);
          } else if (response.status === 500) {
            $state.go('routes.internalError', metadata);
          } else if (response.status === 503) {
            $state.go('routes.serviceUnavailable', metadata);
          } else {
            $state.go('routes.defaultError', metadata);
          }
        }
      }
    };

    $rootScope.$on(
      '$stateChangeError',
      function (event, toState, toParams, fromState, fromParams, error) {
        var metadata = {
          error: error,
          state: toState,
          params: toParams,
          oldState: fromState,
          oldParams: fromParams
        };
        console.log('State Error', metadata);
        if ($location.host() !== 'localhost') {
          $state.go('routes.internalError', metadata);
        }
      }
    );

    $rootScope.$on(
      '$stateNotFound',
      function (event, unfoundState, fromState, fromParams) {
        var metadata = {
          error: event,
          state: fromState,
          params: fromParams,
          unfound: unfoundState
        };
        console.log('State Error', metadata);
        if ($location.host() !== 'localhost') {
          $state.go('routes.notFound', metadata);
        }
      }
    );

    return service;
  }
]);
